import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FeatureModule } from './feature/feature.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { Reducers } from './app-store/state/state.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { Effects } from './app-store/state/state.effects';
import { MaterialModule } from './shared/material.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxImageCompressService } from 'ngx-image-compress';
import { AgmCoreModule } from '@agm/core';
import { ApiProxyInterceptor, DEFAULT_TIMEOUT } from './shared/token.interceptor';
import { AdalService } from './core/services/adal.service';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoRootModule } from './transloco-root.module';
// import { MsalService } from './msal/services/msal.service';
// import { MsalModule } from './msal/msal.module';
import {
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration
} from '@azure/msal-angular';
import { MSALInstanceFactory, MSALGuardConfigFactory, MSALInterceptorConfigFactory } from './msalConfig';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

export const protectedResourceMap: [string, string[]][] = [
  ['https://graph.microsoft.com', ['https://graph.microsoft.com/User.ReadBasic.All']],
  ['https://41ff26dc-250f-4b13-8981-739be8610c21/Covid19Compliance', ['https://41ff26dc-250f-4b13-8981-739be8610c21/Covid19Compliance']]
];


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FeatureModule,
    BrowserAnimationsModule,
    HttpClientModule, TranslocoModule, TranslocoRootModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyA-r_HcwUkqr1vqY9jlJ_jN7wgA4TKey-I',
      libraries: ['places']
    }),
    MatButtonModule, MatDividerModule, MatIconModule,
    StoreModule.forRoot({ appData: Reducers }),
    EffectsModule.forRoot(Effects),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    MaterialModule,
    ServiceWorkerModule.register('master-service.js', { enabled: environment.production }),
    // MsalModule.forRoot({
    //   auth: {
    //     clientId: environment.authConfig.clientId,
    //     authority: environment.authConfig.authority,
    //     redirectUri: environment.authConfig.redirectUri
    //   },
    //   cache: {
    //     cacheLocation: "localStorage", // This configures where your cache will be stored
    //     storeAuthStateInCookie: false,
    //   }
    // },
    //   {
    //     popUp: environment.authConfig.popUp,
    //     consentScopes: ["openid", "profile", "User.Read"],
    //   })
  ],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    AdalService,
    NgxImageCompressService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiProxyInterceptor,
      multi: true
    },
    { provide: DEFAULT_TIMEOUT, useValue: 120000 }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
